'use client';

import React from 'react';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { CustomButton } from '@/components/ui/CustomButton';

export const Customer500Error = () => {
  const router = useRouter();

  return (
    <div className="h-auto">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row mt-6 md:mt-0 lg:gap-10">
          <div className="w-full lg:w-1/2 flex flex-col lg:justify-center pb-10">
            <h1 className="text-4xl md:text-5xl font-650 mb-6 text-[#373945] xl:w-[35rem]">
              <span className="text-[#A51367]">500</span> Internal server error
            </h1>
            <p className="text-3xl font-semibold mb-4 text-[#373945]">
              Sorry! The server encountered an error and could not complete your request.
            </p>
            <p className="text-2xl font-semibold mb-4 text-[#373945]">
              We are working on fixing the problem.
            </p>
            <div className="flex flex-wrap gap-4 pt-5">
              <Link href="/" className="cursor-pointer primary-magenta-large flex items-center">
                Home<ArrowRight className="ml-2 h-4 w-4"/>
              </Link>
              <CustomButton
                variant="secondaryMagentaLarge"
                onClick={() => router.back()}
                className="cursor-pointer !border-none !shadow-none !bg-none !bg-transparent"
              >
                Back
                <ArrowRight className="ml-2 h-4 w-4" />
              </CustomButton>
            </div>
          </div>
          <div className="pb-12">
            <img src="/img/error/500-cust.webp" alt="500" className="w-full"/>
          </div>
        </div>
      </div>
    </div>
  );
};
